import "./About.module.css";
import Header from "@/reusable_sections/Header";
import AboutEagleExteriors from "./sections/AboutEagleExteriors";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <AboutEagleExteriors />
      <Footer />
    </div>;
}